import(/* webpackMode: "eager" */ "/home/gitlab-runner/builds/2dvQn7My/0/mprog/airport-appliance_frontend/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/gitlab-runner/builds/2dvQn7My/0/mprog/airport-appliance_frontend/src/assets/images/customerPickupMap.webp");
;
import(/* webpackMode: "eager" */ "/home/gitlab-runner/builds/2dvQn7My/0/mprog/airport-appliance_frontend/src/assets/images/static/CustomerPickupBanner.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/gitlab-runner/builds/2dvQn7My/0/mprog/airport-appliance_frontend/src/components/DynamicImages/DynamicImage.jsx");
